/* eslint-disable max-len */
import React from 'react';
import { ALL_JOB_QUESTIONS_TYPE } from '../interfaces/jobInterface';
import { VIDEO_STATUS } from '../interfaces/videoInterface';
import { QuestionItem } from './QuestionItem';

interface IProps {
  questions: ALL_JOB_QUESTIONS_TYPE[],
  currentQuestion: number;
  isPracticeMode: boolean;
  questionsStatus: VIDEO_STATUS[];
}

export const QuestionsList:React.FC<IProps> = ({
  questions, currentQuestion, isPracticeMode, questionsStatus,
}) => (
  <div className="myinterview-widget-questions-list myinterview-widget--rtl-support">
    {questions.map((question, idx) => (
      <QuestionItem
        key={question.question}
        questionObj={question}
        questionNumber={idx + 1}
        currentQuestion={currentQuestion}
        isPracticeMode={isPracticeMode}
        questionStatus={questionsStatus[idx]}
      />
    ))}
  </div>
);
